import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const Map = () => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const [settings, setSettings] = useState({
    map_latitude: '-1.9573476',
    map_longitude: '30.1110451',
    map_zoom: '17',
    map_address: 'Amani Hotel, Remera, Kigali, Rwanda',
    map_enabled: 'true'
  });

  useEffect(() => {
    fetchMapSettings();
  }, []);

  const fetchMapSettings = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/settings/public`);
      setSettings(prev => ({ ...prev, ...response.data }));
    } catch (error) {
      console.error('Error fetching map settings:', error);
    }
  };

  useEffect(() => {
    if (!mapRef.current || !settings.map_enabled || mapInstanceRef.current) return;

    const lat = parseFloat(settings.map_latitude);
    const lng = parseFloat(settings.map_longitude);
    const zoom = parseInt(settings.map_zoom) || 17;

    const map = L.map(mapRef.current, {
      center: [lat, lng],
      zoom: zoom,
      zoomControl: true,
      // Style the attribution control
      attributionControl: true,
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 19,
    }).addTo(map);

    L.marker([lat, lng]).addTo(map)
      .bindPopup(`<strong>${settings.map_address}</strong><br /><a href="https://www.google.com/maps/dir//${lat},${lng}" target="_blank">Get Directions →</a>`)
      .openPopup();

    mapInstanceRef.current = map;

    // Custom style the attribution after it's rendered
    setTimeout(() => {
      const attribution = document.querySelector('.leaflet-control-attribution');
      if (attribution) {
        attribution.style.backgroundColor = 'rgba(0,0,0,0.5)';
        attribution.style.color = '#aaa';
        attribution.style.fontSize = '10px';
        attribution.style.padding = '2px 8px';
        attribution.style.borderRadius = '4px';
        attribution.style.bottom = '5px';
        attribution.style.right = '5px';
        // Change link color
        const links = attribution.querySelectorAll('a');
        links.forEach(link => {
          link.style.color = '#fff';
        });
      }
    }, 100);

    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, [settings]);

  if (settings.map_enabled !== 'true') {
    return null;
  }

  return (
    <div className="w-full">
      <div 
        ref={mapRef} 
        className="w-full h-64 md:h-80 lg:h-96 rounded-xl overflow-hidden shadow-lg"
        style={{ backgroundColor: '#f0f0f0' }}
      />
      <div className="mt-3 flex flex-wrap items-center justify-between gap-2 text-sm">
        <div className="flex items-center gap-2 text-gray-400">
          <span>📍</span>
          <span>{settings.map_address}</span>
        </div>
        <a 
          href={`https://www.google.com/maps/dir//${settings.map_latitude},${settings.map_longitude}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-orange-500 hover:underline text-sm"
        >
          Get Directions →
        </a>
      </div>
    </div>
  );
};

export default Map;